// extracted by mini-css-extract-plugin
export default {"root":"Requests_root__+TjjA","buttons":"Requests_buttons__K-MUa"};